import React from 'react';
import * as Types from 'pages/General/typings';
import classnames from 'classnames';
import _get from 'lodash/get';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  onChange: (field: string, value?: boolean | string | null) => void;
  values: Types.GeneralValues;
}

function CustomNavigationTab({ onChange, values }: Props) {
  const classes = useStyles();

  const handleChangeCustomEnabled = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange('client.settings.customNavLink.enabled', e.target.checked);

  const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange('client.settings.customNavLink.displayName', e.currentTarget.value);

  const handleChangeUrl = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange('client.settings.customNavLink.url', e.currentTarget.value);

  return (
    <Card>
      <CardHeader
        action={
          <Switch
            checked={values.client.settings.customNavLink.enabled}
            inputProps={{ 'aria-label': 'custom navbar switch' }}
            onChange={handleChangeCustomEnabled}
          />
        }
        title="Extra Navigation Tab"
        subheader="Add another custom tab in the navigation bar to link to your website."
      />
      <Divider />
      <CardContent className={classes.content}>
        <div className={classnames(classes.column, classes.leftColumn)}>
          <Typography className={classes.label} variant="body2">
            Tab Name:
          </Typography>
          <Typography className={classes.label} variant="body2">
            Link:
          </Typography>
        </div>
        <div className={classnames(classes.column, classes.rightColumn)}>
          <TextField
            className={classnames(classes.textField, classes.marginBottom)}
            id="nav-tab-name"
            disabled={!_get(values, 'client.settings.customNavLink.enabled')}
            value={values.client.settings.customNavLink.displayName}
            onChange={handleChangeName}
            size="small"
          />
          <TextField
            className={classes.textField}
            id="nav-tab-url"
            disabled={!_get(values, 'client.settings.customNavLink.enabled')}
            value={values.client.settings.customNavLink.url}
            onChange={handleChangeUrl}
            size="small"
          />
        </div>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  helpLink: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
    paddingTop: 0,
  },
  content: {
    display: 'flex',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  leftColumn: {
    marginTop: theme.spacing(0.75),
  },
  rightColumn: {
    marginLeft: theme.spacing(2),
  },
  label: {
    minHeight: theme.spacing(4),
  },
  textField: {
    minWidth: 240,
  },
  marginBottom: {
    marginBottom: theme.spacing(),
  },
}));

export default CustomNavigationTab;
